/**
 * Utilities for applying custom code (safely, consistently)
 * @module
 */

var createError = require('custom-error');
var di = require('../di');
var Logger = require('../utils/logger');

var CSP_MODE = __CSP__;
var EXEC_WITH_JQUERY = __EXEC_WITH_JQUERY__;

/**
 * Error applying/evaluating custom code
 */
var ExecError = exports.Error = createError('ExecError');

/**
 * Apply {fn} with {args}
 *
 * If __EXEC_WITH_JQUERY__ is set, append jquery utils value to args (we assume that "$" is the first "additional" argument)
 *
 * @param {Function} fn
 * @param {Array.<*>} [args] args to apply, or undefined for no args
 * @returns {*} the return value of fn
 * @throws {ExecError} if fn throws
 */
exports.apply = function(fn:Function, args?:any[]): any {
  args = args || [];
  if (EXEC_WITH_JQUERY) {
    args = args.concat(di.get('env/jquery'));
  }
  try {
    return fn.apply(undefined, args);
  } catch(e) {
    Logger.warn('Error applying function', fn, 'with args:', args, e);
    throw new ExecError(e);
  }
};

/**
 * Evaluate {str} and return the result
 *
 * Not supported in CSP mode
 *
 * @param {string} str
 * @returns {*} the value of the expression represented by str
 * @throws {ExecError} if eval fails
 */
exports.eval = function(str:string): any {
  if (CSP_MODE) {
    throw new ExecError('eval is not supported in CSP mode');
  } else {
    try {
      if (EXEC_WITH_JQUERY) {
        str = 'var $ = optimizely.get(\'jquery\');' + str;
      }

      // TODO(tyler): use "globalEval" to avoid attaching to this function's scope
      return eval(str); // eslint-disable-line no-eval
    } catch(e) {
      Logger.warn('Error executing JS:', str, e);
      throw new ExecError(e);
    }
  }
};

if (__TEST__) {
  exports.__getCSPMode = function() {
    return CSP_MODE;
  };

  exports.__setCSPMode = function(mode) {
    CSP_MODE = mode;
  };

  exports.__getExecWithJQuery = function() {
    return EXEC_WITH_JQUERY;
  };

  exports.__setExecWithJQuery = function(execWithJQuery) {
    EXEC_WITH_JQUERY = execWithJQuery;
  };
}
